<div class="flex flex-col max-w-[40rem] md:min-w-[28rem] h-full relative">
    <!-- Loading -->
    <div class="relative m-auto" *ngIf="loading">
        <div class="m-auto w-80 relative">
            <mat-progress-bar class="w-full" [color]="'primary'" [mode]="'indeterminate'"></mat-progress-bar>
        </div>
        <div class="m-auto mt-5">
            <span class="justify-center flex text-gray-500 text-[14px]">Recuperando dados da ata</span>
        </div>
    </div>

    <!-- Content -->
    <div class="w-full h-full" *ngIf="!loading && minute">
        <!-- Header -->
            <div class="flex px-6 pt-5 pb-3 w-full relative">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:view_list" class="icon-size-6 text-blue-600"></mat-icon>
                </div>
                <div class="px-2">
                    <div class="w-full leading-10">
                        <span class="text-[24px] font-[600] font-remote">Dados da ata</span>
                    </div>
                </div>
                <div (click)="close('close')" class="mx-4 rounded-full hover:bg-gray-100 cursor-pointer absolute right-0 p-2 w-[44px] h-[44px] top-[20px]">
                    <mat-icon class="text-gray-700 hover:text-gray-500 icon-size-7" svgIcon="mat_solid:close"></mat-icon>
                </div>
            </div>

        <!-- Content with scroll -->
        <div class="w-full overflow-y-auto absolute h-[calc(100%-145px)] px-6">
            <!-- Info Cards -->
            <div class="grid grid-cols-2 gap-4 mb-6">
                <div class="flex items-center gap-3 rounded-xl px-4 py-3 bg-blue-50">
                    <div class="bg-blue-200 rounded-xl p-2.5">
                        <mat-icon class="icon-size-5 text-blue-900" svgIcon="heroicons_outline:tag"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-inter font-[500] text-[12px] text-blue-700 uppercase tracking-wider">Tipo</span>
                         <span class="font-inter font-[600] text-[14px] text-blue-900">{{ getTypeLabel(minute.type) }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-3 rounded-xl px-4 py-3 bg-purple-50">
                    <div class="bg-purple-200 rounded-xl p-2.5">
                        <mat-icon class="icon-size-5 text-purple-900" svgIcon="heroicons_outline:calendar"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-inter font-[500] text-[12px] text-purple-700 uppercase tracking-wider">Data</span>
                        <span class="font-inter font-[600] text-[14px] text-purple-900">{{ minute.meetingDate | date:'dd/MM/yyyy' }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-3 rounded-xl px-4 py-3 bg-emerald-50">
                    <div class="bg-emerald-200 rounded-xl p-2.5">
                        <mat-icon class="icon-size-5 text-emerald-900" svgIcon="heroicons_outline:check-circle"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-inter font-[500] text-[12px] text-emerald-700 uppercase tracking-wider">Status</span>
                         <span class="font-inter font-[600] text-[14px] text-emerald-900">{{ getStatusLabel(minute.status) }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-3 rounded-xl px-4 py-3 bg-gray-100">
                    <div class="bg-gray-200 rounded-xl p-2.5">
                        <mat-icon class="icon-size-5 text-gray-700" svgIcon="heroicons_outline:clock"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-inter font-[500] text-[12px] text-gray-500 uppercase tracking-wider">Criado em</span>
                        <span class="font-inter font-[600] text-[14px] text-gray-800">{{ minute.createdAt | date:'dd/MM/yyyy' }}</span>
                    </div>
                </div>
            </div>

            <!-- Participantes -->
            <div *ngIf="minute.participants && minute.participants.length > 0" class="mb-6">
                <div class="flex w-full py-3">
                    <div class="p-2 rounded-xl bg-blue-100 h-[40px]">
                        <mat-icon svgIcon="mat_solid:group" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Participantes</span>
                        </div>
                    </div>
                </div>
                <div class="flex flex-wrap gap-2 bg-gray-50 rounded-xl p-4">
                    <div *ngFor="let participant of minute.participants"
                         class="flex items-center gap-1.5 bg-blue-200 rounded-full px-3 py-1">
                        <div class="w-6 h-6 rounded-full overflow-hidden flex-shrink-0 bg-blue-100 flex items-center justify-center">
                            <img *ngIf="participant.avatar" class="object-cover w-full h-full" [src]="participant.avatar">
                            <span *ngIf="!participant.avatar" class="font-['lexend'] font-800 text-[11px] text-blue-600">{{ participant.fullName?.charAt(0) }}</span>
                        </div>
                        <span class="text-[12px] font-medium text-blue-900">{{ participant.fullName?.split(' ')[0] }}</span>
                    </div>
                </div>
            </div>

            <!-- Pauta -->
            <div class="mb-6">
                <div class="flex w-full py-3">
                    <div class="p-2 rounded-xl bg-blue-100 h-[40px]">
                        <mat-icon svgIcon="mat_solid:view_list" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Pauta</span>
                        </div>
                    </div>
                </div>
                <div class="font-inter font-[400] text-[14px] text-gray-600 bg-gray-50 rounded-xl p-4 max-w-none" [innerHTML]="getAgendaHtml()"></div>
            </div>

            <!-- Deliberações -->
            <div class="mb-6">
                <div class="flex w-full py-3">
                    <div class="p-2 rounded-xl bg-blue-100 h-[40px]">
                        <mat-icon svgIcon="mat_solid:gavel" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Deliberações/Decisões</span>
                        </div>
                    </div>
                </div>
                <div class="font-inter font-[400] text-[14px] text-gray-600 bg-gray-50 rounded-xl p-4 max-w-none" [innerHTML]="getDeliberationsHtml()"></div>
            </div>

            <!-- Áudio -->
            <div *ngIf="minute.audioFileUrl" class="mb-6">
                <div class="flex w-full py-3">
                    <div class="p-2 rounded-xl bg-blue-100 h-[40px]">
                        <mat-icon svgIcon="mat_solid:headphones" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Áudio da reunião</span>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 rounded-xl p-4">
                    <audio controls class="w-full h-10" [src]="getSafeAudioUrl()"></audio>
                </div>
            </div>

            <!-- Anexo -->
            <div *ngIf="minute.attachmentUrl" class="mb-6">
                <h4 class="font-remote font-[500] text-[16px] text-gray-800 mb-2">Anexo</h4>
                <a [href]="minute.attachmentUrl" target="_blank" class="flex items-center gap-3 rounded-xl px-4 py-3 bg-amber-50 hover:bg-amber-100 cursor-pointer">
                    <mat-icon class="icon-size-5 text-amber-700" svgIcon="heroicons_outline:document"></mat-icon>
                    <span class="font-inter font-[500] text-[14px] text-amber-800">{{ minute.attachmentName || 'Baixar anexo' }}</span>
                </a>
            </div>
        </div>

        <!-- Footer -->
        <div class="absolute flex bottom-0 sm:mt-0 px-6 pb-4 pt-4 w-full justify-between items-center">
            <!-- Botão Exportar à esquerda -->
            <button (click)="exportReport()" class="flex px-6 py-2 rounded-3xl bg-emerald-50 hover:bg-emerald-100 cursor-pointer" [disabled]="loadingExport">
                <mat-icon class="icon-size-5 text-emerald-600 mr-2" svgIcon="heroicons_outline:document-text" *ngIf="!loadingExport"></mat-icon>
                <span class="font-remote font-[400] text-[15px] text-emerald-600" *ngIf="!loadingExport">Exportar</span>
                <mat-progress-spinner *ngIf="loadingExport" [diameter]="20" [mode]="'indeterminate'" class="spinner-emerald"></mat-progress-spinner>
            </button>

            <!-- Botões à direita -->
            <div class="flex flex-row-reverse gap-3">
                <button (click)="edit()" class="flex px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] cursor-pointer">
                    <span class="mr-2 font-remote font-[400] text-[15px] text-white">Editar</span>
                    <mat-icon class="icon-size-5 text-white" svgIcon="mat_solid:edit"></mat-icon>
                </button>
                <button (click)="delete()" class="flex px-6 py-2 rounded-3xl bg-red-50 hover:bg-red-100 cursor-pointer" [disabled]="loadingDelete">
                    <span class="mr-2 font-remote font-[400] text-[15px] text-red-600" *ngIf="!loadingDelete">Excluir</span>
                    <mat-icon class="icon-size-5 text-red-600" svgIcon="heroicons_outline:trash" *ngIf="!loadingDelete"></mat-icon>
                    <mat-progress-spinner *ngIf="loadingDelete" [diameter]="20" [mode]="'indeterminate'" class="spinner-red"></mat-progress-spinner>
                </button>
            </div>
        </div>
    </div>
</div>
